import learningDevelopment from "./user"

export const LDReducers = {
  learningDevelopment: learningDevelopment.reducer
}
